(function () {
  function toggle(item, toggleBtn, answer) {
    var isOpen = item.classList.contains('is-open');
    if (isOpen) {
      answer.style.height = answer.scrollHeight + 'px';
      requestAnimationFrame(function () {
        answer.style.height = '0px';
      });
      item.classList.remove('is-open');
      toggleBtn.setAttribute('aria-expanded', 'false');
    } else {
      item.classList.add('is-open');
      toggleBtn.setAttribute('aria-expanded', 'true');
      answer.style.height = answer.scrollHeight + 'px';
      answer.addEventListener(
        'transitionend',
        function handler() {
          if (item.classList.contains('is-open')) answer.style.height = 'auto';
          answer.removeEventListener('transitionend', handler);
        },
        { once: true }
      );
    }
  }

  function init(section) {
    var items = section.querySelectorAll('[data-faq-item]');
    items.forEach(function (item) {
      var toggleBtn = item.querySelector('[data-faq-toggle]');
      var answer = item.querySelector('[data-faq-answer]');
      if (!toggleBtn || !answer) return;
      toggleBtn.addEventListener('click', function () {
        if (answer.style.height === 'auto') {
          answer.style.height = answer.scrollHeight + 'px';
        }
        toggle(item, toggleBtn, answer);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-hoad-faq]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-hoad-faq]');
    if (section) init(section);
  });
})();
